<div class="connect-bim360-project-wrapper">
  <div class="title_close">
    <h3 class="title">{{ 'sources.autodeskAccount.ConnectBim360' | translate }}</h3>
    <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
  </div>

  <div class="info">
    {{ 'sources.autodeskAccount.ConnectBim360Info' | translate }}
  </div>

  <div class="client-id_app-name">
    <mat-form-field>
      <mat-label>{{ 'sources.autodeskAccount.ClientId' | translate }}</mat-label>
      <input matInput readonly [ngModel]="data.clientId">
      <mat-icon
        matSuffix
        [cdkCopyToClipboard]="data.clientId"
        (cdkCopyToClipboardCopied)="onCopyClientId()"
        class="copy-icon blue">content_copy
      </mat-icon>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'sources.autodeskAccount.AppName' | translate }}</mat-label>
      <input matInput readonly [ngModel]="data.appName">
      <mat-icon matSuffix
                [cdkCopyToClipboard]="data.appName"
                (cdkCopyToClipboardCopied)="onCopyAppName()"
                class="copy-icon blue">content_copy
      </mat-icon>
    </mat-form-field>
  </div>

  <div class="step-by-step" [@.disabled]="disableAnimation">
    <mat-expansion-panel class="mat-elevation-z" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="title">{{ 'sources.autodeskAccount.stepByStepInfo.title' | translate }}</p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content-wrapper">
        <ul>
          <li>
            <div class="text-content">
              <span class="counter">1</span>
              <p class="text">
                {{ 'sources.autodeskAccount.stepByStepInfo.step1' | translate }}
              </p>
            </div>
          </li>
          <li>
            <div class="text-content">
              <span class="counter">2</span>
              <p class="text">{{ 'sources.autodeskAccount.stepByStepInfo.step2' | translate }}</p>
            </div>
            <img class="info-image" src="/assets/img/bim360-auth-second-step.png" alt="">
          </li>
          <li>
            <div class="text-content">
              <span class="counter">3</span>
              <p class="text">{{ 'sources.autodeskAccount.stepByStepInfo.step3' | translate }}</p>
            </div>
            <img class="info-image" src="/assets/img/bim360-auth-third-step.png" alt="">
          </li>
          <li>
            <div class="text-content">
              <span class="counter">4</span>
              <p class="text">{{ 'sources.autodeskAccount.stepByStepInfo.step4' | translate }}</p>
            </div>
          </li>
          <li>
            <div class="text-content">
              <span class="counter">5</span>
              <p class="text">{{ 'sources.autodeskAccount.stepByStepInfo.step5' | translate }}</p>
            </div>
          </li>
          <li>
            <div class="text-content">
              <span class="counter">6</span>
              <p class="text">{{ 'sources.autodeskAccount.stepByStepInfo.step6' | translate }}</p>
            </div>
          </li>
          <li>
            <div class="text-content">
              <span class="counter">7</span>
              <p class="text">{{ 'sources.autodeskAccount.stepByStepInfo.step7' | translate }}</p>
            </div>
          </li>
          <li>
            <div class="text-content">
              <span class="counter">8</span>
              <p class="text">{{ 'sources.autodeskAccount.stepByStepInfo.step8' | translate }}</p>
            </div>
            <img class="info-image" src="/assets/img/bim360-auth-eighth-step.png" alt="">
          </li>
        </ul>
      </div>
    </mat-expansion-panel>
  </div>
</div>
